<template>
  <div :style="{ height: height }" class="sellCenter">
    <div class="inputWrap">
      <div class="header" ref="header">
        <div class="StoreWallateRechargeTitle">
          <el-page-header @back="goBack" content=""> </el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'storeSellOrder' }"
              ><span class="titleText">销售订单</span></el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ name: 'mutlOrderSettingPrice' }"
              ><span class="titleText">修改订单价格</span></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>

        <div>
          <el-button
            v-loading="loading"
            type="info"
            size="mini"
            @click="onSubmit"
          >
            提交修改
          </el-button>
        </div>
      </div>

      <div
        :style="{
          height: formHeight + 'px',
          backgroundColor: '#fff',
          overflow: 'scroll',
        }"
        class="formBox"
      >
        <div class="formInnerBox">
          <el-form ref="form" :model="form" size="mini" label-width="80px">
            <div class="formInfo">
              <el-alert
                v-show="showErr.show"
                :title="showErr.text"
                type="warning"
                :closable="false"
                show-icon
              >
              </el-alert>
            </div>
            <el-form-item label="订单编号：">
              <div class="green">{{ currentEditRow.order_id }}</div>
            </el-form-item>
            <el-form-item label="卖家昵称：">
              <div class="green">{{ currentEditRow.buy_name }}</div>
            </el-form-item>
            <el-form-item label="订单商品：">
              <el-table
                :data="form.products"
                border
                ref="tableRef"
                @row-click="onRowClick"
                size="mini"
                :style="{ 'background-color': 'transparent' }"
                :header-cell-style="{ 'background-color': '#f8f8f8' }"
              >
                <el-table-column
                  align="center"
                  label="序号"
                  type="index"
                  width="100"
                >
                </el-table-column>

                <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="p_name"
                  label="商品封面图"
                  width="100"
                >
                  <div slot-scope="scope">
                    <el-image
                      style="width: 80px; height: 80px"
                      :src="getImageUrl(scope.row.imgurl)"
                      fit="contain"
                    ></el-image>
                  </div>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="p_name"
                  label="商品名称"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="price"
                  label="单价"
                  width="130"
                >
                  <div slot-scope="scope">
                    <el-input
                      v-model="scope.row.price"
                      placeholder=""
                      type="number"
                    ></el-input>
                  </div>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="number"
                  label="数量"
                  width="130"
                >
                  <div slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="scope.row.number"
                      placeholder=""
                    ></el-input>
                  </div>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="totalWeight"
                  label="重量"
                  width="130"
                >
                  <div slot-scope="scope">
                    <el-input
                      type="number"
                      v-model="scope.row.totalWeight"
                      placeholder=""
                    ></el-input>
                  </div>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  align="center"
                  prop="totalWeight"
                  label="小计(元)"
                  width="150"
                >
                  <div slot-scope="scope">
                    <div class="red">
                      {{ getUPrice(scope.row) }}
                    </div>
                  </div>
                </el-table-column>
              </el-table>
            </el-form-item>

            <div class="formInnerBox" :style="{ marginTop: '20px' }">
              <el-form-item label="运费：">
                <el-input type="number" v-model="form.trans_money">
                  <template slot="prepend">
                    <div>+</div>
                  </template>
                  <template slot="append">
                    <div>元</div>
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div class="formInnerBox">
              <el-form-item label="损耗：">
                <el-input type="number" v-model="form.wastage_money">
                  <template slot="prepend">
                    <div>-</div>
                  </template>
                  <template slot="append">
                    <div>元</div>
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="合计(元)：">
              <div class="red">
                {{ totalPrice }} = {{ uPrice }} +{{ form.trans_money || 0 }}+{{
                  form.wastage_money || 0
                }}
              </div>
            </el-form-item>
            <el-form-item label="公式：">
              <div class="labelValueText">合计=总价+运费-损耗</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { setOrderList, getImageUrl } from "@/api/api";

export default {
  props: ["height"],
  data() {
    return {
      tabHeight: "300px",
      form: {
        trans_money: 0,
        wastage_money: 0,
        products: [],
      },
      formHeight: "",
      showErr: {
        show: false,
        text: "",
      },
      loading: false,
    };
  },
  created() {
    this.getImageUrl = getImageUrl;
  },

  mounted() {
    this.setFormHeight();
    window.addEventListener("resize", this.setFormHeight);
    this.initForm();
    console.log("currentEditRow", this.currentEditRow);
  },
  computed: {
    ...mapState(["userInfo", "companyInfo", "currentEditRow"]),
    totalPrice() {
      let { trans_money, wastage_money } = this.form;
      return (
        Number(this.uPrice || 0) +
        Number(trans_money || 0) -
        (wastage_money || 0)
      ).toFixed(2);
    },
    uPrice() {
      let _uPrice = 0;
      this.form.products.forEach((item) => {
        let { unit, buyUnit, number, price, totalWeight } = item;
        _uPrice += unit == buyUnit ? number * price : totalWeight * price;
      });
      return _uPrice.toFixed(2);
    },
  },
  methods: {
    getUPrice(row) {
      let { unit, buyUnit, number, price, totalWeight } = row;
      return unit == buyUnit ? number * price : totalWeight * price;
    },
    initForm() {
      this.form = {
        trans_money: this.currentEditRow.trans_money || 0,
        wastage_money: this.currentEditRow.wastage_money || 0,
        products: this.currentEditRow.products || [],
      };
      console.log(" this.form", this.form);
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      });
    },
    onRowClick() {},
    goBack() {
      this.$router.go(-1);
    },
    setFormHeight() {
      setTimeout(() => {
        this.formHeight =
          parseFloat(this.height) - this.$refs.header.clientHeight - 100;
      }, 100);
    },
     getJSON(){
        let {products} = this.form
        let _json =[]
        products.map((item)=>{
            let {p_id,price,totalWeight,number} = item
            _json.push({
                p_id,
                number,
                price,
                weight:totalWeight
            })
        })
        return JSON.stringify(_json)
    },
    onSubmit() {
      console.log("this.form", this.form);

      let { trans_money, wastage_money } = this.form;

      if (isNaN(trans_money)) {
        this.showErr = {
          show: true,
          text: "运费金额应为数字",
        };
        return;
      }
      if (isNaN(wastage_money)) {
        this.showErr = {
          show: true,
          text: "损耗金额应为数字",
        };
        return;
      }

      if (this.uPrice <= 0) {
        this.showErr = {
          show: true,
          text: "价格应为正值",
        };
        return;
      }

      if (
        this.form.products.some((item) => {
          return item.price < 0;
        })
      ) {
        this.showErr = {
          show: true,
          text: "商品单价应为正值",
        };
        return;
      }

      if (
        this.form.products.some((item) => {
          return item.number < 0;
        })
      ) {
        this.showErr = {
          show: true,
          text: "商品数量应为正值",
        };
        return;
      }

      if (
        this.form.products.some((item) => {
          return item.totalWeight < 0;
        })
      ) {
        this.showErr = {
          show: true,
          text: "商品数量应为正值",
        };
        return;
      }

      this.showErr = {
        show: false,
        text: "",
      };

      let { access_token } = this.userInfo;

      // return
      let url = setOrderList;

      let data = {
        access_token,
        orderId: this.currentEditRow.id,
        trans_money:this.form.trans_money,
        wastage_money:this.form.wastage_money,
        ops: this.getJSON(),
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            console.log(data);
            this.$router.go(-1);
            this.$message({
              message: "订单修改成功",
              type: "success",
            });
          } else {
            this.$alert(JSON.stringify(res.data.resultMsg || "请求异常"));
          }
        })
        .catch((err) => {
          if (err) {
            this.$alert(JSON.stringify(err));
          } else {
            this.$alert("请求异常");
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 20px;
}
.formBox {
  margin-top: 20px;
  padding: 20px;
}

.formInnerBox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 550px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  width: 300px;
  height: 30px;
  margin-bottom: 20px;
}
.userName {
  color: #666;
  font-size: 13px;
}
.StoreWallateRechargeTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.labelValueText {
  color: #666;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/MutlOrderSettingPrice.vue